import { useIsHost } from "playroomkit";
import { useEffect } from "react";
import { Matrix4, Vector3 } from "three";
import { HandleType } from "../engine/HandleType";
import { ECS } from "../engine/ecs/state";
import { useAddSceneItem } from "../engine/useAddSceneItem";

const ForwardHelper = new Vector3();
const RotationMatrixHelper = new Matrix4();
export const Hive = () => {
	const addSceneItem = useAddSceneItem();
	const hive = ECS.useCurrentEntity();

	const isHost = useIsHost();
	useEffect(() => {
		console.log("starting interval");
		if (!isHost) {
			return undefined;
		}
		const interval = setInterval(() => {
			ForwardHelper.set(1, 0, 0);
			RotationMatrixHelper.extractRotation(hive.transform.matrix);
			ForwardHelper.applyMatrix4(RotationMatrixHelper);
			ForwardHelper.normalize();
			addSceneItem(
				"workerBee",
				{},
				{
					transform: hive.transform.matrix,
					handleType: HandleType.NONE,
					colliders: false,
					scale: [0.2, 0.2, 0.2],
					physical: "dynamic",
					velocities: {
						linear: ForwardHelper.multiplyScalar(1),
						angular: { x: 0, y: 0, z: 0 },
					},
				},
			);
		}, 5000);

		return () => clearInterval(interval);
	}, [addSceneItem, hive, isHost]);

	return (
		<mesh>
			<boxGeometry args={[0.1, 0.1, 0.1]} />
			<meshStandardMaterial color="yellow" />
		</mesh>
	);
};

export const WorkerBee = () => {
	const bee = ECS.useCurrentEntity();

	useEffect(() => {
		const timeout = setTimeout(() => {
			ECS.world.remove(bee);
		}, 20000);

		return () => clearTimeout(timeout);
	});

	return (
		<mesh>
			<boxGeometry args={[0.1, 0.1, 0.1]} />
			<meshStandardMaterial color="yellow" />
		</mesh>
	);
};

export const Resource = () => {
	return (
		<mesh>
			<boxGeometry args={[0.1, 0.1, 0.1]} />
			<meshStandardMaterial color="yellow" />
		</mesh>
	);
};
